<template>
  <svg class="barchart" :width="width" :height="height"></svg>
</template>

<script>
import * as d3 from "d3";
import d3tip from "d3-tip";

export default {
  mounted: function() {
    this.svg = d3.select(this.$el);
    this.colors = d3.scaleOrdinal(d3[this.colorScheme]);

    this.tip = d3tip()
      .attr("class", "d3-tip")
      .offset([-10, 0])
      .html(function(d) {
        return (
          "<div><span style='color:white'>" +
          d.name +
          "</span></div>" +
          "<div><span>Value:</span> <span style='color:white'>" +
          d.value +
          "</span></div>"
        );
      });

    this.svg.call(this.tip);

    this.drawChart(this.xRange);
  },
  watch: {
    xRange: function(newXRange) {
      this.drawChart(newXRange);
    }
  },
  methods: {
    drawChart: function(xRange) {
      this.svg.selectAll("*").remove();
      let yScale = d3
        .scaleLinear()
        .domain(this.yDomain)
        .range([0, 500]);

      let xScale = d3
        .scaleBand()
        .domain(this.data.map(d => d.name))
        .range(xRange);

      let yAxis = d3.axisLeft().scale(yScale);
      let xAxis = d3.axisBottom().scale(xScale);

      let rects = this.svg.selectAll("rect").data(this.data);

      let colors = this.colors;
      //enter
      rects
        .enter()
        .append("rect")
        .attr("fill", function(d) {
          return colors(d.value);
        })
        .attr("y", function(d) {
          return yScale(d["value"]);
        })
        .attr("width", 14)
        .attr("height", function(d) {
          return yScale(0) - yScale(d["value"]);
        })
        .attr("x", function(d) {
          return xScale(d["name"]);
        })
        .on("mouseover", this.tip.show)
        .on("mouseout", this.tip.hide);

      this.svg
        .append("g")
        .attr("transform", "translate(0,0)")
        .call(yAxis);

      this.svg
        .append("g")
        .attr("transform", "translate(0,500)")
        .call(xAxis)
        .selectAll("text")
        .style("text-anchor", "end")
        .attr("dx", "-.8em")
        .attr("dy", ".15em")
        .attr("transform", "rotate(-80)");

      // exit
      rects.exit().remove();
    }
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    width: {
      default: "600"
    },
    height: {
      default: "600"
    },
    colorScheme: {
      default: "schemeAccent"
    },
    yDomain: {
      required: true
    },
    xRange: {
      default: () => [0, 400]
    }
  }
};
</script>

<style>
.barchart {
  /* border: 10px black solid; */
  padding-left: 20px;
  padding-top: 20px;
}

.d3-tip {
  line-height: 1;
  font: 14px sans-serif;
  padding: 12px;
  background: rgba(0, 0, 0, 0.8);
  color: rgb(185, 185, 185);
  border-radius: 2px;
}

/* Creates a small triangle extender for the tooltip */
.d3-tip:after {
  box-sizing: border-box;
  display: inline;
  font-size: 10px;
  width: 100%;
  line-height: 1;
  color: rgba(0, 0, 0, 0.8);
  content: "\25BC";
  position: absolute;
  text-align: center;
}

.d3-tip.n:after {
  margin: -1px 0 0 0;
  top: 100%;
  left: 0;
}
</style>
